export const MAIN_CLASS_NAME = 'project-file-table';
export const NAME_CLASS_NAME = `${MAIN_CLASS_NAME}__name`;
